import React, { Component } from "react";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebProgressbarComponent } from "../common/selltowebprogressbar/SelltoWebProgressbarComponent";
import { SellToWebButtonComponent } from "../common/selltowebbutton/SellToWebButtonComponent";

export class OfferErrorRouteComponent extends Component {
    constructor(props) {
        super(props)
        this.onActionClick = this.onActionClick.bind(this);
    }

    pageTitle = "Offer Error";

    componentDidMount() {
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/offer-error", pageType: "Consumer", isLoggedIn: "No", properties: { tenantName: this.props.tenantName, siteName: this.props.siteName } });
            CommonService.clientAzureStorageLog("OfferErrorRouteComponent", "componentDidMount", null, null, null, null, this.props.applicationInsights);
        }
        catch (error) {
            console.logError(error, "OfferErrorRouteComponent", "componentDidMount", this.state.vinOrLicensePlate);
        }
    }

    onActionClick() {
        try {
            CommonService.clientAzureStorageLog("OfferErrorRouteComponent", "onActionClick", null, null, null, null, this.props.applicationInsights);
            let Url = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Offer Error", "Default", "Action Url").Value;
            window.open(Url, '_blank');
        }
        catch (error) {
            console.logError(error, "OfferErrorRouteComponent", "onActionClick");
        }
    }

    render() {
        let headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Offer Error", "Default", "Header Html")?.Value;
        if (!headerHtml) {
            headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Header Html")?.Value ?? "";
        }

        let footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Offer Error", "Default", "Footer Html")?.Value;
        if (!footerHtml) {
            footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Footer Html")?.Value ?? "";
        }

        let bodyHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Offer Error", "Default", "Body Html")?.Value ?? "";
        return <div className="ac-site ac-offererror">
            <header className="ac-site-header ac-offererror-header" dangerouslySetInnerHTML={{ __html: headerHtml }} />
            <SellToWebProgressbarComponent progressIndex={null} />
            <section className="consumer-page">
                <section className="consumer-main">
                    <section className="ac-site-body ac-offererror-body" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
                    <div style={{ "textAlign": "center" }}>
                        <SellToWebButtonComponent onClick={this.onActionClick} value={CommonService.getSiteAttributeValue(this.props.siteAttributes, "Offer Error", "Default", "Action Text")?.Value ?? ""} />
                    </div>
                </section>
            </section>
            <footer className="ac-site-footer ac-offererror-footer" dangerouslySetInnerHTML={{ __html: footerHtml }} />
        </div>;
    }
}